import { render, staticRenderFns } from "./SVGConnection.vue?vue&type=template&id=fea35c52&"
import script from "./SVGConnection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SVGConnection.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SVGConnection.vue?vue&type=style&index=0&id=fea35c52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports